<ndt-blocked-phone-number-register-view
   [callState]="callState$ | async"
   [dataSource]="dataSource$ | async"
   [isLoading]="isLoading$ | async"
   [hasNextPage]="hasNextPage$ | async"
   [pagingCallState]="pagingCallState$ | async"
   [totalCount]="totalCount$ | async"
   (create)="onCreate()"
   [name]="entityName"
   [columns]="columns"
   [blockedPhoneNumberPrivileges]="blockedPhoneNumberPrivileges$ | async"
   (loadMore)="onLoadMore()"
   (quickFilterChange)="onQuickFilterChange($event)"
   (deleteBlockedPhoneNumber)="onDeleteBlockedPhoneNumber($event)"
></ndt-blocked-phone-number-register-view>
